import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import Markdown from 'markdown-to-jsx';
import { useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';
import { cn } from '@bridebook/aura';
import { MultilineEllipsis } from '@bridebook/ui';
import renderers from './markdown-renderers';

type Description = {
  description1?: string;
  description2?: string;
};

interface IProps {
  data: Description | null;
}

const LocationDescription = ({ data }: IProps) => {
  const { t } = useTranslation('supplier');
  const [descriptionVisible, showDescription2] = useState(false);
  const options = renderers(() => showDescription2(true));
  const description = data?.description2;
  const isMobile = useSelector(getIsMobile);
  const [isExpanded, setIsExpanded] = useState(false);
  const showFullText = useCallback(() => setIsExpanded(true), []);

  const getMoreLinkMarkdown = () =>
    data?.description2 && !descriptionVisible ? ` [${t('button.readMore')}](more)` : '';

  return (
    <div className="bsdesc">
      {Boolean(data?.description1) && (
        <>
          {isMobile && !isExpanded ? (
            <>
              <MultilineEllipsis lines={2}>
                <Markdown options={options} className={cn('bsdesc-md', description && 'mb-[5px]')}>
                  {data?.description1 || ''}
                </Markdown>
              </MultilineEllipsis>
              <div onClick={showFullText}>
                <Markdown className="mb-[5px]" options={options}>
                  {getMoreLinkMarkdown()}
                </Markdown>
              </div>
            </>
          ) : (
            <Markdown options={options} className={cn('bsdesc-md', description && 'mb-[5px]')}>
              {data?.description1 + getMoreLinkMarkdown() || ''}
            </Markdown>
          )}
        </>
      )}
      {Boolean(data?.description2) && (
        <Markdown options={options} className={descriptionVisible ? 'inline' : 'hidden'}>
          {data?.description2 || ''}
        </Markdown>
      )}
    </div>
  );
};

export default LocationDescription;
